@if (!loaded) {
<mat-spinner
  diameter="150"
  class="spinner" />
} @if (loaded) {
<app-header nav="0" />
} @if (loaded && loadedUser) {
<div class="content">
  <div [innerHTML]="content | userReplace"></div>
  <mat-tab-group>
    <mat-tab label="My Tasks">
      <app-task-view type="task"></app-task-view>
    </mat-tab>
    <mat-tab label="My Attentions">
      <app-task-view type="attention"></app-task-view>
    </mat-tab>
    @if (hasGroupEditRights()) {
    <mat-tab label="Group Rights">
      <app-group-link></app-group-link>
    </mat-tab>
    }
  </mat-tab-group>
</div>
}
